import React, { useState, useEffect, useContext, useRef } from "react";
import { IoIosSend } from "react-icons/io";
import { FaFileImage } from "react-icons/fa";
import { MdEmojiEmotions } from "react-icons/md";
import EmojiPicker from "emoji-picker-react";
import { iconsDocs } from "../../services/icones-fichiers";
import { DisplayDiscussionForMiniScreenContext } from "../../contexts/DisplayDiscussionForMiniScreenContext";
import { AuthContext } from "../../contexts/AuthContext";
import { WorkspaceContext } from "../../contexts/WorkspaceContext";
import { socket } from "../../services/socket";

export default function EditableDiv({
  contentRef,
  onSubmit,
  files,
  setFiles,
  setFilesSelected,
  conversation,
}) {
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const boxRefEmojiPiker = useRef(null);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const { destinataire, crew } = useContext(
    DisplayDiscussionForMiniScreenContext
  );
  const { user } = useContext(AuthContext);
  const { currentWorkspace } = useContext(WorkspaceContext);
  const workspaceId = currentWorkspace?._id;
  const [roomId] = useState(
    conversation === "inbox"
      ? user.userId > destinataire.userId
        ? `${user.userId}_${destinataire.userId}`
        : `${destinataire.userId}_${user.userId}`
      : crew.roomId
  );
  const typingTimeoutRef = useRef(null);

  const handleEmojiClick = (emoji) => {
    if (contentRef.current) {
      contentRef.current.textContent += emoji;
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (conversation === "inbox") {
        socket.emit("stopTypingInbox", { stoppeur: user.userId, roomId, workspaceId });
      } else {
        socket.emit("stopTypingGroupe", { stoppeur: user.userId, roomId, workspaceId });
      }
      onSubmit();
    }
  };
  useEffect(() => {
    setTheme(localStorage.getItem("theme"));
  }, [theme]);

  // Fermer si clic à l'extérieur
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        boxRefEmojiPiker.current &&
        !boxRefEmojiPiker.current.contains(event.target) &&
        !event.target.closest(".emoji-toggle-button")
      ) {
        setShowEmojiPicker(false);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <div
        className="col-1 tyn-chat-form-enter d-none"
        style={{ width: "0.333333%" }}
      ></div>
      <div className="tyn-chat-form-enter col-9">
        {files.filesSelected && files.files.length > 0 && (
          <div
            onClick={() => {
              setFilesSelected(false);
              setFiles([]);
            }}
            style={{
              display: "flex",
              alignItems: "center",
              gap: "4px",
              padding: "4px 8px",
              cursor: "pointer",
            }}
          >
            {files.files.slice(0, 4).map((f, i) => {
              const ext = f.name.split(".").pop().toLowerCase();
              const mimeExt = f.type.split("/")[1]?.toLowerCase();
              const isImage = [
                "jpeg",
                "jpg",
                "png",
                "gif",
                "bmp",
                "webp",
                "tiff",
                "svg",
              ].includes(mimeExt);
              if (isImage) {
                return <FaFileImage key={i} style={{ fontSize: "30px" }} />;
              }
              const iconData = iconsDocs.find(
                (icon) => icon.extension === ext || icon.extension === mimeExt
              );
              return (
                <span key={i}>
                  {iconData
                    ? iconData.icon
                    : iconsDocs[iconsDocs.length - 1].icon}
                </span>
              );
            })}
            {files.files.length > 4 && (
              <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                +{files.files.length - 4}
              </span>
            )}
          </div>
        )}
        <div
          ref={contentRef}
          onKeyDown={handleKeyDown}
          onInput={() => {
            clearTimeout(typingTimeoutRef.current);
            if (conversation === "inbox") {
              socket.emit("typingInbox", { userId: user.userId, roomId, workspaceId });
              typingTimeoutRef.current = setTimeout(() => {
                socket.emit("stopTypingInbox", { stoppeur: user.userId, roomId, workspaceId });
              }, 3000);
            } else {
              socket.emit("typingGroupe", { user, roomId, workspaceId });
              typingTimeoutRef.current = setTimeout(() => {
                socket.emit("stopTypingGroupe", {
                  stoppeur: user.userId,
                  roomId,
                  workspaceId,
                });
              }, 3000);
            }
          }}
          className="tyn-chat-form-input max-height-125px"
          id="tynChatInput"
          contentEditable={true}
          style={{ paddingRight: "29px", textAlign: "justify" }}
        ></div>
        {showEmojiPicker && (
          <div ref={boxRefEmojiPiker}>
            <EmojiPicker
              emojiStyle="native"
              style={{
                position: "absolute",
                bottom: "104px",
                right: "23px",
                zIndex: 100,
              }}
              className={`show animate__animated animate__backInLeft ${
                theme === "light" ? "f8f8f8" : "bg-dark"
              }`}
              onEmojiClick={(event) => handleEmojiClick(event.emoji)}
            />
          </div>
        )}
        <ul className="tyn-list-inline me-n2 my-1">
          <li>
            <MdEmojiEmotions
              className="emoji-toggle-button"
              onClick={(evt) => {
                evt.stopPropagation();
                setShowEmojiPicker(!showEmojiPicker);
              }}
              style={{
                fontSize: "25px",
                cursor: "pointer",
                position:"absolute",
                right:"50px",
                bottom:"31px"
              }}
            />
          </li>
          <li>
            <button
              type="button"
              onClick={() => {
                if (conversation === "inbox") {
                  socket.emit("stopTypingInbox", { stoppeur: user.userId, roomId, workspaceId });
                } else {
                  socket.emit("stopTypingGroupe", {
                    stoppeur: user.userId,
                    roomId,
                    workspaceId,
                  });
                }
                onSubmit();
              }}
              className="btn btn-icon btn-white btn-md btn-pill"
              id="tynChatSend"
              style={{ height: "auto", width: "auto" }}
            >
              <IoIosSend
                style={{ fontSize: "22px", height: "auto", width: "auto" }}
              />
            </button>
          </li>
        </ul>
      </div>
    </>
  );
}
